import React from "react";

export const DislikeIcon = ({
  width = 20,
  height = 20,
  color = "currentColor",
}: {
  width?: number;
  height?: number;
  color?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 2v11h5V2h-5zm-2 11V2H10.91c-.55 0-1.07.26-1.41.7L5.92 7.39c-.26.34-.42.77-.42 1.21V11c0 1.1.9 2 2 2h4.09l-.61 2.93-.02.11c0 .41.17.79.44 1.06l1.43 1.41 4.58-4.59c.37-.37.59-.88.59-1.41V4z" />
  </svg>
);
